import React from 'react';
import ApplicationSettingsForm from '../settings/ApplicationSettingsForm';
import type { EmbeddedInConfigurationHub } from './models';

const ApplicationSettingsModule: React.FC<EmbeddedInConfigurationHub> = ({ embedded = true }) => (
  <ApplicationSettingsForm embedded={embedded} />
);

export default ApplicationSettingsModule;
